// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InteractionTwoToneSvg from "@ant-design/icons-svg/es/asn/InteractionTwoTone";
import AntdIcon from '../components/AntdIcon';

var InteractionTwoTone = function InteractionTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: InteractionTwoToneSvg
  }));
};

InteractionTwoTone.displayName = 'InteractionTwoTone';
export default React.forwardRef(InteractionTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/InteractionTwoTone.js
// module id = 1379
// module chunks = 0